






































import Vue from "vue";
import Component from "vue-class-component";
import {
  UserManagementForgotPasswordRequest,
  UserManagerService,
} from "@/common/api/index";
import QErrors from "@/common/qErrors.vue";
import qNotify from "@/common/qNotify";

@Component({
  name: "ForgotPassword",
  components: {
    QErrors,
  },
  directives: {},
})
export default class ForgotPassword extends Vue {
  public form: UserManagementForgotPasswordRequest = {
    email: "",
  };
  public errors = {};

  public async submit() {
    let response;
    try {
      response = await UserManagerService.adminForgotPassword(this.form);
    } catch (error) {
      response = error.body;
      this.errors = response.errors;
      console.log("Response", response);
    }

    if (response.status == "error") {
      qNotify.error({
        text: response.message,
      });
    } else {
      qNotify.success({
        text: response.message,
      });
      this.$emit("submit", this.form.email);
    }
  }

  public hide() {
    this.$emit("hide");
  }
}
